import { render, staticRenderFns } from "./PolicyFormAccount.vue?vue&type=template&id=44978377&scoped=true&"
import script from "./PolicyFormAccount.vue?vue&type=script&lang=ts&"
export * from "./PolicyFormAccount.vue?vue&type=script&lang=ts&"
import style0 from "./PolicyFormAccount.vue?vue&type=style&index=0&id=44978377&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44978377",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
